export const environment = {
    production: false,
    sw: false,
    serverUrl: 'https://api.stelmach-zlotnik.sandbox.cloud.codelabs.work',
    features: {
        rolesCreate: false,
        departmentsCreate: false,
        divisionsCreate: false,
        rolesDelete: false,
        departmentsDelete: false,
        divisionsDelete: false,
        materialsCreate: false,
        elementsCreate: false,
        materialsDelete: false,
        elementsDelete: false,
    },
    languages: {
        default: 'pl-PL',
        supported: [
            {
                key: 'pl-PL',
                regulations: '',
            },
        ],
    },
};
